/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable array-callback-return */
import React from 'react';

import { INotification } from '../../mock/notifications.mock';
import { NotificationsWrapper, NotificationsInfo } from './styles';

interface NotificationProps {
  data: INotification;
}

const PayHistoryNotification: React.FC<NotificationProps> = ({ data }) => (
  <NotificationsWrapper>
    <div key={data.id}>
      <NotificationsInfo>
        <span>Employees Notified</span>
        <span>{data.employees_notified}</span>
      </NotificationsInfo>
      <NotificationsInfo>
        <span>Employees Viewed Statements</span>
        <span>{data.employees_viewed}</span>
      </NotificationsInfo>
      <NotificationsInfo>
        <span>Supervisors Opened PDFs</span>
        <span>{data.supervisors_pdf}</span>
      </NotificationsInfo>
    </div>
  </NotificationsWrapper>
);

export default PayHistoryNotification;
